export default "__VITE_ASSET__CT1g6u15__"